"use strict";

module.exports = lens;
function lens(getter, setter) {
  return function (v) {
    return {
      get: function () {
        return getter(v);
      },
      set: function (val) {
        return setter(val, v);
      }
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/lens/index.js
// module id = 432
// module chunks = 0